import Button from 'components/form/Button';
import React from 'react';
interface BackButtonProps {
  text: string;
}

const BackButton = ({ text }: BackButtonProps) => {
  return (
    <Button className="!pl-0">
      <div className="flex items-center gap-x-3 hover:text-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="h-6 w-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
          />
        </svg>
        <h3 className="text-[20px] font-medium">{text}</h3>
      </div>
    </Button>
  );
};

export default BackButton;
